

import React , {useEffect} from 'react';
import {Routes , Route} from 'react-router-dom'

import  './App.css'


import Devotional from './components/pages/index.jsx'
import DevotionalHome from './components/pages/DevotionalHome/index.jsx'

import DevotionalContentsPage from './components/pages/devotionalContentsPage.jsx';

import DevotionalSubPages from './components/pages/devotionalSubPages.jsx';

import DevotionalVideoList from './components/pages/DevotionalVideoList/index.jsx';

import DevotionalVideos from './components/pages/DevotionalVideos/index.jsx'

import DevotionalVideo from './components/pages/DevotionalVideo/index.jsx'

import DevotionalContent from './components/pages/DevotionalContent/index.jsx';

import DevotionalWeekly from './components/pages/DevotionalWeekly/index.jsx'


import DevotionalTithi from './components/pages/DevotionalTithi/index.jsx'
import AdSenseLoader from './components/common/AdSenseLoader.jsx';

// const NewsContent = loadable(() => import('./components/pages/content/contentPage.jsx'), {
//   fallback: null,
// });

import PageNotFound from './components/pages/pageNotFound.jsx';
import DevotionalNewArticles from './components/pages/devotionalNewArticles.jsx';


 
const App = ({data}) =>{
            
        let isMobile = data?.[1].isMobile || false
     
     

      
         useEffect(() => {
    /* Disable right click */
    const handleContextMenu = (e) => {
      e.preventDefault()
    }

    /* Disable copy, cut, paste */
    const handleCopy = (e) => e.preventDefault()
    const handleCut = (e) => e.preventDefault()
    const handlePaste = (e) => e.preventDefault()

    /* Disable keyboard shortcuts (Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+S, Ctrl+U) */
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ['c', 'v', 'x', 's', 'u'].includes(e.key.toLowerCase())
      ) {
        e.preventDefault()
      }
    }

    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('copy', handleCopy)
    document.addEventListener('cut', handleCut)
    document.addEventListener('paste', handlePaste)
    document.addEventListener('keydown', handleKeyDown)

    /* Disable image drag */
    const disableImageDrag = () => {
      document.querySelectorAll('img').forEach((img) => {
        img.setAttribute('draggable', 'false')
      })
    }

    disableImageDrag()

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
      document.removeEventListener('copy', handleCopy)
      document.removeEventListener('cut', handleCut)
      document.removeEventListener('paste', handlePaste)
      document.removeEventListener('keydown', handleKeyDown)
    }
          }, [])


         useEffect(() => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
}, []); 

    return(
     
      <main className="App d-flex flex-column align-items-center">
        <AdSenseLoader />
        <Routes>
           <Route path="/" element={<Devotional  isMobile={isMobile} />}>

                        <Route index element={<DevotionalHome data={data} />} />
                        
                         <Route path="contents/:category" element={<DevotionalContentsPage  data={data} />} />
                              
                         <Route path="subpages/:category" element={<DevotionalSubPages data={data} />} />
                         <Route path="newarticles/new-articles.html" element={<DevotionalNewArticles data={data} />} />

                         <Route path="videolist/:video" element={<DevotionalVideoList data={data} />} />
 
                           <Route path="videos/bhaktivideos.html" element={<DevotionalVideos data={data} />} />

                        <Route path="video/:content" element={<DevotionalVideo data = {data} />} />

                        <Route path="content/:content" element={<DevotionalContent  data={data} />} />
                        
                      <Route path="weekly/:charecter" element={<DevotionalWeekly data={data} />} />

                         <Route path="tithi.html" element={<DevotionalTithi data={data} />} />
                        

                    </Route> 


            <Route path="*" element={<PageNotFound />} />
           </Routes>
     
     </main>
    )
}


export default App;
